import { useQuery } from "@tanstack/react-query"
import { deliveryApi } from "@/services/delivery-api"
import { queryKeys } from "./query-keys"
import { useAuthReady } from "./use-auth-ready"

export function useReportDeliveryTypes() {
  const isAuthReady = useAuthReady()

  return useQuery({
    queryKey: queryKeys.deliveryTypes.all,
    queryFn: () => deliveryApi.getReportDeliveryTypes(),
    enabled: isAuthReady,
  })
}
